const monthNames = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export function formatDate(dateStr: string | undefined = ''): string {
  try {
    const [sanitizedDateStr] = dateStr.replace('Z', '').split('+');
    const date = new Date(`${sanitizedDateStr}Z`);

    if (isNaN(date.getTime())) {
      return '';
    }

    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return [day, month, year].join(' ');
  } catch {
    return '';
  }
}
